export default "__VITE_ASSET__Dt_A5UQA__"